import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../components/modal/modal";

const AddVacancy = () => {
  // Инициализируем хук перевода
  const { t, i18n } = useTranslation();
  
  const industriesObj = t("industries", { returnObjects: true }) || {};
  const industriesList = Object.values(industriesObj);
  
  const [formData, setFormData] = useState({
    industry1: "",
    industry2: "",
    industry3: "",
    workplace: "",
    workname: "",
    type: "",        
    rate: "",        
    experience: "",  
    age: "",
    salary: "",
    currency: "AMD",
    considerAlso: "",
    deadline: "",
    description: "",
    responsibilities: [""],
    requirements: [""],
    conditions: [""],
    additional: "",
    freelance: false,
    inclusive: false,
    undefinedAge: false,
    contract: false, 
    bonuses: false,
    allCountryUsers: false,
    disabilitiesUsers: false,
    undefinedSalary: false, 
    salaryType: "fixed", 
  });

  const [userData, setUserData] = useState({
    user_id: null,
    companyName: "",
    companyLogo: "",
  });

  // Получаем данные пользователя
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const res = await fetch(`/api/get_user.php?id=${userId}`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error(t("Ошибка получения данных пользователя"));
        const data = await res.json();
        if (data.success) {
          setUserData({
            user_id: data.user.id,
            companyName: data.user.companyName,
            companyLogo: data.user.companyLogo,
            background: data.user.background || "",
          });
        }
      } catch (err) {
        console.error(t("Ошибка fetch get_user.php:"), err);
      }
    };
    fetchUser();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFreelanceChange = (e) => {
    const { checked } = e.target;
    setFormData({
      ...formData,
      freelance: checked,
      workplace: checked ? t("remote") : formData.workplace,
    });
  };

  const handleArrayChange = (index, field, value) => {
    const updatedArray = [...formData[field]];
    updatedArray[index] = value;
    setFormData({ ...formData, [field]: updatedArray });
  };

  const addField = (field) => {
    setFormData({ ...formData, [field]: [...formData[field], ""] });
  };

  const removeField = (field, index) => {
    const updatedArray = [...formData[field]];
    updatedArray.splice(index, 1);
    setFormData({ ...formData, [field]: updatedArray });
  };

  const getTypeOptions = () => [
    { value: "Permanent", label: t("Permanent") },
    { value: "Temporary", label: t("Temporary") },
    { value: "Contract", label: t("Contract") },
    { value: "Other", label: t("Other") },
  ];

  const getRateOptions = () => [
    { value: "Full-time", label: t("Full-time") },
    { value: "Part-time", label: t("Part-time") },
    { value: "Other", label: t("Other") },
  ];

  const getExperienceOptions = () => [
    { value: "no", label: t("no") },
    { value: "beginner", label: t("beginner") },
    { value: "mid", label: t("mid") },
    { value: "senior", label: t("senior") },
    { value: "undefined", label: t("undefined") },
  ];

  const currencyOptions = [
    { value: "AMD", label: "֏", flag: "🇦🇲" },
    { value: "USD", label: "$", flag: "🇺🇸" },
    { value: "EUR", label: "€", flag: "🇪🇺" },
    { value: "RUB", label: "₽", flag: "🇷🇺" },
  ];

  const handleOptionSelect = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.workname.trim() ||
      !formData.industry1.trim() ||
      !formData.type.trim() ||
      !formData.rate.trim() ||
      !formData.experience.trim() ||
      (!formData.undefinedAge && !formData.age.trim()) ||
      (!formData.contract && !formData.undefinedSalary && !formData.salary.trim()) ||
      !formData.description.trim() ||
      formData.responsibilities.some((i) => !i.trim()) ||
      formData.requirements.some((i) => !i.trim()) ||
      formData.conditions.some((i) => !i.trim())
    ) {
      setModalMessage({
        title: t("error"),
        text: t("allfields"),
        success: false,
        ok: t("ok"),
      });
      return;
    }

    const payload = {
      ...formData,
      type: t(formData.type), 
      rate: t(formData.rate),
      experience: t(formData.experience),
      workplace: formData.freelance ? t("remote") : formData.workplace,
      salaryType: formData.contract ? "contract" : formData.undefinedSalary ? "undefined" : "fixed",
      salary: formData.contract ? t("Contract") : formData.undefinedSalary ? t("Indefinite") : formData.salary,
      currency: formData.contract || formData.undefinedSalary ? "" : formData.currency || "",
      age: formData.undefinedAge ? t("Indefinite") : formData.age,
      user_id: userData.user_id,
      companyName: userData.companyName,
      companyLogo: userData.companyLogo,
      background: userData.background || "",
      allCountryUsers: formData.allCountryUsers ? t("allcountryusers") : "",
      disabilitiesUsers: formData.disabilitiesUsers ? t("disabilitiesusers") : "",
    };

    try {
      const response = await fetch("/api/add_vacancy.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        setModalMessage({
          ok: t("ok"),
          title: t("success"),
          text: t("vacancy_created_success"),
          success: true,
          onClose: () => window.location.reload(),
        });
      } else {
        setModalMessage({
          ok: t("ok"),
          title: t("error"),
          text: result.message || t("error_adding_vacancy"),
          success: false,
        });
      }
    } catch (err) {
      setModalMessage({
        ok: t("ok"),
        title: t("error"),
        text: t("server_error"),
        success: false,
      });
    }
  };

  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);
  const [showRateDropdown, setShowRateDropdown] = useState(false);
  const [showExperienceDropdown, setShowExperienceDropdown] = useState(false);
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);

  return (
    <section className="p-4 sm:p-8 opacity-0 animate-[showtitle_1s_forwards] flex justify-center items-center w-full">
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          success={modalMessage.success}
          ok={modalMessage.ok}
          onClose={() => {
            if (modalMessage.onClose) modalMessage.onClose();
            setModalMessage(null);
          }}
        />
      )}

      <div className="w-full max-w-3xl bg-white rounded-xl overflow-hidden shadow-md">
        <h3 className="font-bold tracking-widest bg-[#006674] py-4 text-white w-full text-center uppercase text-xl sm:text-2xl md:text-3xl px-4">
          {t("addvacancie")}
        </h3>

        {/* Переключатели языка */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mt-6 px-6">
          <span className="text-md font-medium text-gray-600 whitespace-nowrap">{t("post")}</span>
          <div className="grid grid-cols-3 gap-2 w-full sm:w-auto">
            <button
              type="button"
              onClick={() => i18n.changeLanguage("am")}
              className={`py-2 px-3 text-xs sm:text-sm md:w-[130px] rounded-md cursor-pointer shadow-md transition-all duration-200 text-center ${
                i18n.language === "am" ? "bg-[#006674] text-white" : "bg-gray-200 hover:bg-[#006674] hover:text-white"
              }`}
            >
              Հայերեն
            </button>
            <button
              type="button"
              onClick={() => i18n.changeLanguage("ru")}
              className={`py-2 px-3 text-xs sm:text-sm md:w-[130px] rounded-md cursor-pointer shadow-md transition-all duration-200 text-center ${
                i18n.language === "ru" ? "bg-[#006674] text-white" : "bg-gray-200 hover:bg-[#006674] hover:text-white"
              }`}
            >
              Русский
            </button>
            <button
              type="button"
              onClick={() => i18n.changeLanguage("en")}
              className={`py-2 px-3 text-xs sm:text-sm md:w-[130px] rounded-md cursor-pointer shadow-md transition-all duration-200 text-center ${
                i18n.language === "en" ? "bg-[#006674] text-white" : "bg-gray-200 hover:bg-[#006674] hover:text-white"
              }`}
            >
              English
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5 p-4 sm:p-6">
          {/* Название должности */}
          <div className="w-full flex flex-col gap-2">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("positionname")}</label>
            <input
              name="workname"
              value={formData.workname}
              onChange={handleChange}
              className="w-full p-2.5 border rounded-lg outline-none focus:border-[#006674] transition-colors"
            />
          </div>

          {/* Сферы деятельности */}
          <div className="w-full flex flex-col gap-3">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("industry")}</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Сфера 1 */}
              <div className="relative w-full">
                <input
                  type="text"
                  readOnly
                  placeholder={t("sentfirtsspere")}
                  value={formData.industry1}
                  onClick={() => setShowDropdown1(!showDropdown1)}
                  className="w-full py-2.5 px-4 border rounded-lg outline-none cursor-pointer focus:border-[#006674] bg-white"
                />
                {showDropdown1 && (
                  <div className="absolute left-0 right-0 bg-white border rounded-lg p-2 mt-1 z-50 shadow-xl max-h-60 overflow-y-auto">
                    {industriesList.map((label, idx) => (
                      <div
                        key={idx}
                        className="p-2 hover:bg-[#006674] hover:text-white cursor-pointer rounded-md transition-colors"
                        onClick={() => {
                          handleOptionSelect("industry1", label);
                          setShowDropdown1(false);
                        }}
                      >
                        {label}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Сфера 2 */}
              <div className="relative w-full">
                <input
                  type="text"
                  readOnly
                  placeholder={t("sentsecondsspere")}
                  value={formData.industry2}
                  onClick={() => setShowDropdown2(!showDropdown2)}
                  className="w-full py-2.5 px-4 border rounded-lg outline-none cursor-pointer focus:border-[#006674] bg-white"
                />
                {showDropdown2 && (
                  <div className="absolute left-0 right-0 bg-white border rounded-lg p-2 mt-1 z-50 shadow-xl max-h-60 overflow-y-auto">
                    {industriesList.map((label, idx) => (
                      <div
                        key={idx}
                        className="p-2 hover:bg-[#006674] hover:text-white cursor-pointer rounded-md transition-colors"
                        onClick={() => {
                          handleOptionSelect("industry2", label);
                          setShowDropdown2(false);
                        }}
                      >
                        {label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Место работы / Удаленка */}
          <div className="w-full flex flex-col gap-2">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("jobplace")}</label>
            <div className="flex flex-col sm:flex-row gap-3 w-full">
              <label className="flex py-2.5 px-4 w-full sm:w-1/2 cursor-pointer bg-gray-50 text-black transition-all duration-200 hover:bg-gray-100 border rounded-lg justify-start items-center gap-3 select-none">
                <input
                  type="checkbox"
                  name="freelance"
                  checked={formData.freelance}
                  onChange={handleFreelanceChange}
                  className="accent-[#006674] h-4 w-4"
                />
                <span className="text-sm sm:text-base">{t("remote")}</span>
              </label>

              <input
                name="workplace"
                placeholder={t("concreteaddres")}
                value={formData.workplace}
                onChange={handleChange}
                disabled={formData.freelance}
                className={`w-full sm:w-1/2 p-2.5 border rounded-lg outline-none focus:border-[#006674] ${
                  formData.freelance ? "bg-gray-100 cursor-not-allowed text-gray-400" : "bg-white"
                }`}
              />
            </div>
          </div>

          {/* Тип занятости и График работы */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="w-full flex flex-col gap-2">
              <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("EmploymentType")}</label>
              <div className="relative w-full">
                <input
                  type="text"
                  readOnly
                  placeholder={t("choose type")}
                  value={formData.type ? t(formData.type) : ""}
                  onClick={() => setShowTypeDropdown(!showTypeDropdown)}
                  className="w-full py-2.5 px-4 border rounded-lg outline-none cursor-pointer focus:border-[#006674] bg-white"
                />
                {showTypeDropdown && (
                  <div className="absolute left-0 right-0 bg-white border rounded-lg p-2 mt-1 z-50 shadow-xl max-h-60 overflow-y-auto">
                    {getTypeOptions().map((option, idx) => (
                      <div
                        key={idx}
                        className="p-2 hover:bg-[#006674] hover:text-white cursor-pointer rounded-md"
                        onClick={() => {
                          handleOptionSelect("type", option.value);
                          setShowTypeDropdown(false);
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="w-full flex flex-col gap-2">
              <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("EmploymentTime")}</label>
              <div className="relative w-full">
                <input
                  type="text"
                  readOnly
                  placeholder={t("chooseemploymenttime")}
                  value={formData.rate ? t(formData.rate) : ""}
                  onClick={() => setShowRateDropdown(!showRateDropdown)}
                  className="w-full py-2.5 px-4 border rounded-lg outline-none cursor-pointer focus:border-[#006674] bg-white"
                />
                {showRateDropdown && (
                  <div className="absolute left-0 right-0 bg-white border rounded-lg p-2 mt-1 z-50 shadow-xl max-h-60 overflow-y-auto">
                    {getRateOptions().map((option, idx) => (
                      <div
                        key={idx}
                        className="p-2 hover:bg-[#006674] hover:text-white cursor-pointer rounded-md"
                        onClick={() => {
                          handleOptionSelect("rate", option.value);
                          setShowRateDropdown(false);
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Опыт работы */}
          <div className="w-full flex flex-col gap-2">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("Experience")}</label>
            <div className="relative w-full md:w-1/2">
              <input
                type="text"
                readOnly
                placeholder={t("Chooseanexperience")}
                value={formData.experience ? t(formData.experience) : ""}
                onClick={() => setShowExperienceDropdown(!showExperienceDropdown)}
                className="w-full py-2.5 px-4 border rounded-lg outline-none cursor-pointer focus:border-[#006674] bg-white"
              />
              {showExperienceDropdown && (
                <div className="absolute left-0 right-0 bg-white border rounded-lg p-2 mt-1 z-50 shadow-xl max-h-60 overflow-y-auto">
                  {getExperienceOptions().map((option, idx) => (
                    <div
                      key={idx}
                      className="p-2 hover:bg-[#006674] hover:text-white cursor-pointer rounded-md"
                      onClick={() => {
                        handleOptionSelect("experience", option.value);
                        setShowExperienceDropdown(false);
                      }}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Возраст */}
          <div className="w-full flex flex-col gap-2">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("Age")}</label>
            <div className="flex flex-col sm:flex-row gap-3 w-full">
              <label className="flex py-2.5 px-4 w-full sm:w-1/2 cursor-pointer bg-gray-50 border rounded-lg justify-start items-center gap-3 select-none">
                <input
                  type="checkbox"
                  checked={formData.undefinedAge}
                  className="accent-[#006674] h-4 w-4"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      undefinedAge: e.target.checked,
                      age: e.target.checked ? "" : formData.age,
                    })
                  }
                />
                <span className="text-sm sm:text-base">{t("Indefinite")}</span>
              </label>

              <input
                name="age"
                placeholder={t("Specifytheagelimit")}
                value={formData.age}
                onChange={handleChange}
                disabled={formData.undefinedAge}
                className={`w-full sm:w-1/2 p-2.5 border rounded-lg outline-none focus:border-[#006674] ${
                  formData.undefinedAge ? "bg-gray-100 cursor-not-allowed text-gray-400" : "bg-white"
                }`}
              />
            </div>
          </div>

          {/* Зарплата */}
          <div className="w-full flex flex-col gap-3">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("Salary")}</label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <label className="flex py-2.5 px-4 cursor-pointer bg-gray-50 border rounded-lg justify-start items-center gap-3 select-none">
                <input
                  type="checkbox"
                  name="contract"
                  checked={formData.contract}
                  className="accent-[#006674] h-4 w-4"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      contract: e.target.checked,
                      undefinedSalary: e.target.checked ? false : formData.undefinedSalary,
                      salary: e.target.checked ? "" : formData.salary,
                      salaryType: e.target.checked ? "contract" : "fixed",
                    })
                  }
                />
                <span className="text-sm sm:text-base">{t("Contract")}</span>
              </label>

              <label className="flex py-2.5 px-4 cursor-pointer bg-gray-50 border rounded-lg justify-start items-center gap-3 select-none">
                <input
                  type="checkbox"
                  name="undefinedSalary"
                  checked={formData.undefinedSalary}
                  className="accent-[#006674] h-4 w-4"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      undefinedSalary: e.target.checked,
                      contract: e.target.checked ? false : formData.contract,
                      salary: e.target.checked ? "" : formData.salary,
                      salaryType: e.target.checked ? "undefined" : "fixed",
                    })
                  }
                />
                <span className="text-sm sm:text-base">{t("undefined")}</span>
              </label>
            </div>

            {/* Ввод суммы, валюта, бонусы */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full">
              <input
                name="salary"
                placeholder={t("Specifyconcreteorapproximatesalary")}
                value={formData.salary}
                onChange={handleChange}
                disabled={formData.contract || formData.undefinedSalary}
                className={`flex-grow p-2.5 border rounded-lg outline-none focus:border-[#006674] ${
                  formData.contract || formData.undefinedSalary ? "bg-gray-100 cursor-not-allowed text-gray-400" : "bg-white"
                }`}
              />

              {/* Выбор валюты */}
              <div className="relative min-w-[70px]">
                <div
                  className={`p-2.5 border rounded-lg outline-none cursor-pointer focus:border-[#006674] flex items-center justify-between bg-white ${
                    formData.contract || formData.undefinedSalary ? "bg-gray-100 cursor-not-allowed text-gray-400" : ""
                  }`}
                  onClick={() =>
                    !(formData.contract || formData.undefinedSalary) && setShowCurrencyDropdown(!showCurrencyDropdown)
                  }
                >
                  <span className="w-full text-center">{currencyOptions.find((opt) => opt.value === formData.currency)?.label}</span>
                  <span className="text-xs text-gray-400 ml-1">▼</span>
                </div>
                {showCurrencyDropdown && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border rounded-lg shadow-xl z-50 overflow-hidden">
                    {currencyOptions.map((option) => (
                      <div
                        key={option.value}
                        className="p-2.5 hover:bg-[#006674] hover:text-white cursor-pointer text-center transition-colors"
                        onClick={() => {
                          setFormData({ ...formData, currency: option.value });
                          setShowCurrencyDropdown(false);
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Бонусы */}
              <label className="flex py-2.5 px-4 cursor-pointer bg-gray-50 border rounded-lg justify-center sm:justify-start items-center gap-3 select-none whitespace-nowrap">
                <input
                  type="checkbox"
                  name="bonuses"
                  checked={formData.bonuses}
                  className="accent-[#006674] h-4 w-4"
                  onChange={handleChange}
                />
                <span className="text-sm sm:text-base">+ {t("bonuses")}</span>
              </label>
            </div>
          </div>

          {/* Кто рассматривается */}
          <div className="w-full flex flex-col gap-2">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("AlsoConsidered")}</label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full">
              <label className="flex py-2.5 px-4 bg-gray-50 border rounded-lg cursor-pointer hover:bg-gray-100 justify-start items-center gap-3 select-none">
                <input
                  type="checkbox"
                  name="allCountryUsers"
                  checked={formData.allCountryUsers}
                  className="accent-[#006674] h-4 w-4"
                  onChange={handleChange}
                />
                <span className="text-sm sm:text-base">{t("allcountryusers")}</span>
              </label>
              <label className="flex py-2.5 px-4 bg-gray-50 border rounded-lg cursor-pointer hover:bg-gray-100 justify-start items-center gap-3 select-none">
                <input
                  type="checkbox"
                  name="disabilitiesUsers"
                  checked={formData.disabilitiesUsers}
                  className="accent-[#006674] h-4 w-4"
                  onChange={handleChange}
                />
                <span className="text-sm sm:text-base">{t("disabilitiesusers")}</span>
              </label>
            </div>
          </div>

          {/* Описание */}
          <div className="w-full flex flex-col gap-2">
            <label className="text-[#006674] font-semibold uppercase text-sm sm:text-base">{t("DESCRIPTION")}</label>
            <textarea
              name="description"
              rows="4"
              value={formData.description}
              onChange={handleChange}
              className="w-full p-2.5 border rounded-lg outline-none focus:border-[#006674] transition-colors"
            />
          </div>

          {/* Динамические списки: Обязанности, Требования, Условия */}
          {["responsibilities", "requirements", "conditions"].map((field) => (
            <div key={field} className="w-full flex flex-col gap-2">
              <h3 className="font-semibold text-[#006674] uppercase text-sm sm:text-base">
                {field === "responsibilities" && t("RESPONSIBILITIES")}
                {field === "requirements" && t("REQUIREMENTSANDESSENTIALSKILLS")}
                {field === "conditions" && t("TERMS AND BENEFITS")}
              </h3>
              
              {formData[field].map((item, index) => (
                <div key={index} className="flex gap-2 mb-1 items-center w-full">
                  <input
                    type="text"
                    value={item}
                    onChange={(e) => handleArrayChange(index, field, e.target.value)}
                    className="flex-grow p-2.5 border rounded-lg outline-none focus:border-[#006674]"
                  />
                  {index === 0 ? (
                    <button
                      type="button"
                      onClick={() => addField(field)}
                      className="flex justify-center items-center shrink-0 w-10 h-10 bg-[#006674] text-white rounded-full hover:bg-[#005561] transition-colors shadow-sm"
                    >
                      <FontAwesomeIcon icon={faPlus} className="text-sm" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => removeField(field, index)}
                      className="flex justify-center items-center shrink-0 w-10 h-10 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors shadow-sm"
                    >
                      <FontAwesomeIcon icon={faXmark} className="text-sm" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          ))}

          {/* Кнопка отправки */}
          <button
            type="submit"
            className="w-full py-3.5 bg-[#006674] text-white font-bold rounded-lg hover:bg-[#005561] transition duration-200 uppercase tracking-widest cursor-pointer shadow-lg mt-4 text-sm sm:text-base"
          >
            {t("save")}
          </button>
        </form>
      </div>
    </section>
  );
};

export default AddVacancy;